<template>
  <el-dropdown :hide-on-click="false" trigger="click" placement="bottom-start">
    <el-button type="info" style="margin-right: 10px; margin-left: 10px">
      表示項目
      <font-awesome-icon icon="caret-down" style="margin-left: 5px" />
    </el-button>
    <el-dropdown-menu slot="dropdown" v-if="sns_type == 'instagram'">
      <el-dropdown-item @click.native="resetListItems()">初期値に戻す</el-dropdown-item>
      <el-dropdown-item><el-checkbox v-model="item.account_name" :disabled="true">ユーザー名</el-checkbox></el-dropdown-item>
      <el-dropdown-item><el-checkbox v-model="item.personalized_name">DM宛名</el-checkbox></el-dropdown-item>
      <el-dropdown-item><el-checkbox v-model="item.personalized_price">DM報酬金額</el-checkbox></el-dropdown-item>
      <el-dropdown-item><el-checkbox v-model="item.sns">SNS</el-checkbox></el-dropdown-item>
      <el-dropdown-item><el-checkbox v-model="item.gender">性別</el-checkbox></el-dropdown-item>
      <el-dropdown-item><el-checkbox v-model="item.age">年齢</el-checkbox></el-dropdown-item>
      <el-dropdown-item><el-checkbox v-model="item.area">関連エリア</el-checkbox></el-dropdown-item>
      <el-dropdown-item><el-checkbox v-model="item.bio">プロフィール</el-checkbox></el-dropdown-item>
      <el-dropdown-item><el-checkbox v-model="item.score">SCORE</el-checkbox></el-dropdown-item>
      <el-dropdown-item><el-checkbox v-model="item.followers">フォロワー数</el-checkbox></el-dropdown-item>
      <el-dropdown-item><el-checkbox v-model="item.following">フォロー数</el-checkbox></el-dropdown-item>
      <el-dropdown-item><el-checkbox v-model="item.like_count">平均いいね数</el-checkbox></el-dropdown-item>
      <el-dropdown-item><el-checkbox v-model="item.comments_count">平均コメント数</el-checkbox></el-dropdown-item>
      <el-dropdown-item><el-checkbox v-model="item.video_play_count">平均リール再生数(合計)</el-checkbox></el-dropdown-item>
      <el-dropdown-item><el-checkbox v-model="item.video_play_count_organic">平均リール再生数(ｵｰｶﾞﾆｯｸ)</el-checkbox></el-dropdown-item>
      <el-dropdown-item><el-checkbox v-model="item.video_play_count_pr">平均リール再生数(PR)</el-checkbox></el-dropdown-item>
      <el-dropdown-item><el-checkbox v-model="item.video_play_rate">平均リール視聴率(合計)</el-checkbox></el-dropdown-item>
      <el-dropdown-item><el-checkbox v-model="item.video_play_rate_organic">平均リール視聴率(ｵｰｶﾞﾆｯｸ)</el-checkbox></el-dropdown-item>
      <el-dropdown-item><el-checkbox v-model="item.video_play_rate_pr">平均リール視聴率(PR)</el-checkbox></el-dropdown-item>
      <el-dropdown-item><el-checkbox v-model="item.egr">EGR</el-checkbox></el-dropdown-item>
      <el-dropdown-item><el-checkbox v-model="item.egr_only_pr">EGR(PR投稿のみ)</el-checkbox></el-dropdown-item>
      <el-dropdown-item><el-checkbox v-model="item.pr_rate">PR率</el-checkbox></el-dropdown-item>
      <el-dropdown-item><el-checkbox v-model="item.gender_ratio">フォロワー男女比</el-checkbox></el-dropdown-item>
      <el-dropdown-item><el-checkbox v-model="item.main_audience">フォロワー年齢層</el-checkbox></el-dropdown-item>
      <el-dropdown-item><el-checkbox v-model="item.tag">カスタマイズタグ</el-checkbox></el-dropdown-item>
      <el-dropdown-item><el-checkbox v-model="item.status" v-if="!master">ステータス</el-checkbox></el-dropdown-item>
      <el-dropdown-item><el-checkbox v-model="item.comment" v-if="!master">リスト内コメント</el-checkbox></el-dropdown-item>
      <el-dropdown-item><el-checkbox v-model="item.num" v-if="!master">数値</el-checkbox></el-dropdown-item>
      <el-dropdown-item><el-checkbox v-model="item.add_at" v-if="!master">リスト追加日</el-checkbox></el-dropdown-item>
      <el-dropdown-item><el-checkbox v-model="item.recent_post">直近の投稿</el-checkbox></el-dropdown-item>
      <el-dropdown-item><el-checkbox v-model="item.category">関連カテゴリ</el-checkbox></el-dropdown-item>
      <el-dropdown-item><el-checkbox v-model="item.person_title">人物・肩書</el-checkbox></el-dropdown-item>
      <el-dropdown-item><el-checkbox v-model="item.specialty_categories_genres">得意カテゴリー・ジャンル</el-checkbox></el-dropdown-item>
      <el-dropdown-item><el-checkbox v-model="item.post_format">投稿形式</el-checkbox></el-dropdown-item>
      <el-dropdown-item><el-checkbox v-model="item.report_count">レポート起用回数</el-checkbox></el-dropdown-item>
      <el-dropdown-item><el-checkbox v-model="item.avg_report_egr">レポート投稿平均EGR</el-checkbox></el-dropdown-item>
      <el-dropdown-item><el-checkbox v-model="item.avg_report_reach_count">レポート投稿平均リーチ数</el-checkbox></el-dropdown-item>
      <el-dropdown-item><el-checkbox v-model="item.avg_report_like_count">レポート投稿平均いいね数</el-checkbox></el-dropdown-item>
      <el-dropdown-item><el-checkbox v-model="item.avg_report_comments_count">レポート投稿平均コメント数</el-checkbox></el-dropdown-item>
      <el-dropdown-item><el-checkbox v-model="item.avg_report_saves_count">レポート投稿平均保存数</el-checkbox></el-dropdown-item>
      <el-dropdown-item><el-checkbox v-model="item.avg_report_cost">レポート投稿平均コスト</el-checkbox></el-dropdown-item>
      <el-dropdown-item divided disabled>パーソナルデータ</el-dropdown-item>
      <div v-if="!property_loading">
        <el-dropdown-item v-for="property in properties" :key="property.property_id">
          <el-checkbox v-model="item[property.property_name]">{{ property.property }}</el-checkbox>
        </el-dropdown-item>
      </div>
      <el-dropdown-item><el-checkbox v-model="item.note">ノート</el-checkbox></el-dropdown-item>
    </el-dropdown-menu>
    <el-dropdown-menu slot="dropdown" v-if="sns_type == 'youtube'">
      <el-dropdown-item @click.native="resetListItems()">初期値に戻す</el-dropdown-item>
      <el-dropdown-item><el-checkbox v-model="item.channel_name" :disabled="true">チャンネル名</el-checkbox></el-dropdown-item>
      <el-dropdown-item><el-checkbox v-model="item.sns">SNS</el-checkbox></el-dropdown-item>
      <el-dropdown-item><el-checkbox v-model="item.gender">性別</el-checkbox></el-dropdown-item>
      <el-dropdown-item><el-checkbox v-model="item.bio">チャンネル概要</el-checkbox></el-dropdown-item>
      <el-dropdown-item><el-checkbox v-model="item.subscriber">チャンネル登録者数</el-checkbox></el-dropdown-item>
      <el-dropdown-item><el-checkbox v-model="item.viewRate">平均視聴率</el-checkbox></el-dropdown-item>
      <el-dropdown-item><el-checkbox v-model="item.average_viewCount">平均視聴回数</el-checkbox></el-dropdown-item>
      <el-dropdown-item><el-checkbox v-model="item.egr">EGR</el-checkbox></el-dropdown-item>
      <el-dropdown-item><el-checkbox v-model="item.comments_count">平均コメント数</el-checkbox></el-dropdown-item>
      <el-dropdown-item><el-checkbox v-model="item.pr_rate">PR率</el-checkbox></el-dropdown-item>
      <el-dropdown-item><el-checkbox v-model="item.frequency">投稿頻度</el-checkbox></el-dropdown-item>
      <el-dropdown-item><el-checkbox v-model="item.likeCount">平均高評価数</el-checkbox></el-dropdown-item>
      <el-dropdown-item><el-checkbox v-model="item.gender_ratio">フォロワー男女比</el-checkbox></el-dropdown-item>
      <el-dropdown-item><el-checkbox v-model="item.main_audience">フォロワー年齢層</el-checkbox></el-dropdown-item>
      <el-dropdown-item><el-checkbox v-model="item.tag">カスタマイズタグ</el-checkbox></el-dropdown-item>
      <el-dropdown-item><el-checkbox v-model="item.status" v-if="!master">ステータス</el-checkbox></el-dropdown-item>
      <el-dropdown-item><el-checkbox v-model="item.comment" v-if="!master">コメント</el-checkbox></el-dropdown-item>
      <el-dropdown-item><el-checkbox v-model="item.num" v-if="!master">数値</el-checkbox></el-dropdown-item>
      <el-dropdown-item><el-checkbox v-model="item.add_at" v-if="!master">リスト追加日</el-checkbox></el-dropdown-item>
      <el-dropdown-item><el-checkbox v-model="item.recent_post">直近の投稿</el-checkbox></el-dropdown-item>
      <el-dropdown-item divided disabled>パーソナルデータ</el-dropdown-item>
      <div v-if="!property_loading">
        <el-dropdown-item v-for="property in properties" :key="property.property_id">
          <el-checkbox v-model="item[property.property_name]">{{ property.property }}</el-checkbox>
        </el-dropdown-item>
      </div>
      <el-dropdown-item><el-checkbox v-model="item.note">ノート</el-checkbox></el-dropdown-item>
    </el-dropdown-menu>
    <el-dropdown-menu slot="dropdown" v-if="sns_type == 'tiktok'">
      <el-dropdown-item @click.native="resetListItems()">初期値に戻す</el-dropdown-item>
      <el-dropdown-item><el-checkbox v-model="item.channel_name" :disabled="true">ユーザー名</el-checkbox></el-dropdown-item>
      <el-dropdown-item><el-checkbox v-model="item.sns">SNS</el-checkbox></el-dropdown-item>
      <el-dropdown-item><el-checkbox v-model="item.gender">性別</el-checkbox></el-dropdown-item>
      <el-dropdown-item><el-checkbox v-model="item.bio">プロフィール概要</el-checkbox></el-dropdown-item>
      <el-dropdown-item><el-checkbox v-model="item.score">SCORE</el-checkbox></el-dropdown-item>
      <el-dropdown-item><el-checkbox v-model="item.subscriber">フォロワー数</el-checkbox></el-dropdown-item>
      <el-dropdown-item><el-checkbox v-model="item.heartCount">総いいね数</el-checkbox></el-dropdown-item>
      <el-dropdown-item><el-checkbox v-model="item.viewRate">平均視聴率(合計)</el-checkbox></el-dropdown-item>
      <el-dropdown-item><el-checkbox v-model="item.viewRate_organic">平均視聴率(ｵｰｶﾞﾆｯｸ)</el-checkbox></el-dropdown-item>
      <el-dropdown-item><el-checkbox v-model="item.viewRate_pr">平均視聴率(PR)</el-checkbox></el-dropdown-item>
      <el-dropdown-item><el-checkbox v-model="item.average_viewCount_total">平均視聴回数(合計)</el-checkbox></el-dropdown-item>
      <el-dropdown-item><el-checkbox v-model="item.average_viewCount_organic">平均視聴回数(ｵｰｶﾞﾆｯｸ)</el-checkbox></el-dropdown-item>
      <el-dropdown-item><el-checkbox v-model="item.average_viewCount_pr">平均視聴回数(PR)</el-checkbox></el-dropdown-item>
      <el-dropdown-item><el-checkbox v-model="item.like_count">平均いいね数</el-checkbox></el-dropdown-item>
      <el-dropdown-item><el-checkbox v-model="item.comments_count">平均コメント数</el-checkbox></el-dropdown-item>
      <el-dropdown-item><el-checkbox v-model="item.share_count">平均シェア数</el-checkbox></el-dropdown-item>
      <el-dropdown-item><el-checkbox v-model="item.egr">EGR</el-checkbox></el-dropdown-item>
      <el-dropdown-item><el-checkbox v-model="item.pr_rate">PR率</el-checkbox></el-dropdown-item>
      <el-dropdown-item><el-checkbox v-model="item.frequency">投稿頻度</el-checkbox></el-dropdown-item>
      <el-dropdown-item><el-checkbox v-model="item.gender_ratio">フォロワー男女比</el-checkbox></el-dropdown-item>
      <el-dropdown-item><el-checkbox v-model="item.tag">カスタマイズタグ</el-checkbox></el-dropdown-item>
      <el-dropdown-item><el-checkbox v-model="item.status" v-if="!master">ステータス</el-checkbox></el-dropdown-item>
      <el-dropdown-item><el-checkbox v-model="item.comment" v-if="!master">コメント</el-checkbox></el-dropdown-item>
      <el-dropdown-item><el-checkbox v-model="item.num" v-if="!master">数値</el-checkbox></el-dropdown-item>
      <el-dropdown-item><el-checkbox v-model="item.add_at" v-if="!master">リスト追加日</el-checkbox></el-dropdown-item>
      <el-dropdown-item><el-checkbox v-model="item.recent_post">直近の投稿</el-checkbox></el-dropdown-item>
      <el-dropdown-item divided disabled>パーソナルデータ</el-dropdown-item>
      <div v-if="!property_loading">
        <el-dropdown-item v-for="property in properties" :key="property.property_id">
          <el-checkbox v-model="item[property.property_name]">{{ property.property }}</el-checkbox>
        </el-dropdown-item>
      </div>
      <el-dropdown-item><el-checkbox v-model="item.note">ノート</el-checkbox></el-dropdown-item>
    </el-dropdown-menu>
    <el-dropdown-menu slot="dropdown" v-if="sns_type == 'twitter'">
      <el-dropdown-item @click.native="resetListItems()">初期値に戻す</el-dropdown-item>
      <el-dropdown-item><el-checkbox v-model="item.channel_name" :disabled="true">ユーザー名</el-checkbox></el-dropdown-item>
      <el-dropdown-item><el-checkbox v-model="item.sns">SNS</el-checkbox></el-dropdown-item>
      <el-dropdown-item><el-checkbox v-model="item.gender">性別</el-checkbox></el-dropdown-item>
      <el-dropdown-item><el-checkbox v-model="item.bio">プロフィール</el-checkbox></el-dropdown-item>
      <el-dropdown-item><el-checkbox v-model="item.followers">フォロワー数</el-checkbox></el-dropdown-item>
      <el-dropdown-item><el-checkbox v-model="item.like_count">平均いいね</el-checkbox></el-dropdown-item>
      <el-dropdown-item><el-checkbox v-model="item.comments_count">平均コメント</el-checkbox></el-dropdown-item>
      <el-dropdown-item><el-checkbox v-model="item.retweet_count">平均リポスト</el-checkbox></el-dropdown-item>
      <el-dropdown-item><el-checkbox v-model="item.egr">EGR</el-checkbox></el-dropdown-item>
      <el-dropdown-item><el-checkbox v-model="item.pr_rate">PR率</el-checkbox></el-dropdown-item>
      <el-dropdown-item><el-checkbox v-model="item.frequency">投稿頻度</el-checkbox></el-dropdown-item>
      <!-- <el-dropdown-item><el-checkbox v-model="item.gender_ratio">フォロワー男女比</el-checkbox></el-dropdown-item> -->
      <el-dropdown-item><el-checkbox v-model="item.tag">カスタマイズタグ</el-checkbox></el-dropdown-item>
      <el-dropdown-item><el-checkbox v-model="item.status" v-if="!master">ステータス</el-checkbox></el-dropdown-item>
      <el-dropdown-item><el-checkbox v-model="item.comment" v-if="!master">コメント</el-checkbox></el-dropdown-item>
      <el-dropdown-item><el-checkbox v-model="item.num" v-if="!master">数値</el-checkbox></el-dropdown-item>
      <el-dropdown-item><el-checkbox v-model="item.add_at" v-if="!master">リスト追加日</el-checkbox></el-dropdown-item>
      <el-dropdown-item><el-checkbox v-model="item.recent_post">直近の投稿</el-checkbox></el-dropdown-item>
      <el-dropdown-item divided disabled>パーソナルデータ</el-dropdown-item>
      <div v-if="!property_loading">
        <el-dropdown-item v-for="property in properties" :key="property.property_id">
          <el-checkbox v-model="item[property.property_name]">{{ property.property }}</el-checkbox>
        </el-dropdown-item>
      </div>
      <el-dropdown-item><el-checkbox v-model="item.note">ノート</el-checkbox></el-dropdown-item>
    </el-dropdown-menu>
  </el-dropdown>
</template>

<script>
export default {
  name: "listDisplayButton",
  props: ["sns_type", "master", "properties", "property_loading"],
  data() {
    return {};
  },
  computed: {
    item() {
      return this.$store.state.list_item;
    },
  },
  created() {},
  mounted() {},
  methods: {
    resetListItems() {
      this.$store.dispatch("resetListItems");
    },
  },
  watch: {
    item: {
      handler() {
        this.$store.dispatch("saveListItems", this.item);
      },
      deep: true,
    },
  },
};
</script>
